module.exports = __webpack_public_path__ + "static/media/imgop_WinterWheatStraw_StretchedTiff.588e450b.webp";